import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DashboardPage } from './dashboard';
// Import ionic2-rating module
import { Ionic2RatingModule } from 'ionic2-rating';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
	declarations: [
	DashboardPage
	],
	imports: [
	Ionic2RatingModule,
	TranslateModule,
	IonicPageModule.forChild(DashboardPage)
	],
	exports: [
	DashboardPage
	]
})
export class DashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.module.ts